// Mirror of shared/models.py response shapes.

export type GroupBy = "case_id" | "feature_id" | "user_id" | "query_type";

export const GROUP_BY_OPTIONS: { value: GroupBy; label: string }[] = [
  { value: "case_id", label: "Case" },
  { value: "feature_id", label: "Feature" },
  { value: "user_id", label: "User" },
  { value: "query_type", label: "Query type" },
];

// MVP: customer list hardcoded. Could fetch from a future /v1/customers endpoint.
export const CUSTOMERS: { value: string; label: string }[] = [
  { value: "stage", label: "Stage" },
  { value: "secure-bench", label: "Secure Bench" },
  { value: "am-india", label: "AM India" },
  { value: "demo", label: "Demo" },
];

export interface UsageBucket {
  key: string | null;
  total: number;
  event_count: number;
}

export interface UsageResponse {
  customer_id: string;
  start: string;
  end: string;
  filters_applied: Record<string, string>;
  grouped_by: GroupBy | null;
  buckets: UsageBucket[];
  grand_total: number;
}

export interface FilterEntry {
  column: Exclude<GroupBy, never>; // any of the four
  value: string;
}
